import { Component, Input } from '@angular/core';
import { SlotsController } from '@shared/src/controllers/address/slots/slots.controller';
import { PhaseController } from '@shared/src/controllers/route/phase/phase.controller';
import { HColor, HDateHour, HomeController, ShipmentController } from '@shared/src/public-api';
import { TruckingRouteExpandDto } from '@shared/src/dtos/trucking/TruckingRouteExpandDto';
import { TruckingShipmentDto } from '@shared/src/dtos/trucking/TruckingShipmentDto';

@Component({
  selector: 'shared-trucking-shipment-strip-card-component',
  templateUrl: './shared.trucking.shipment.strip.component.html',
  styleUrls: ['./shared.trucking.shipment.strip.component.scss'],
})
export class SharedTruckingShipmentStripComponent {

  public useIonic: boolean = false;

  constructor(protected homeController: HomeController, protected slotsController: SlotsController, protected phaseController: PhaseController, protected shipmentController: ShipmentController) {

  }

  public _shipment: TruckingShipmentDto;
  @Input()
  public get shipment(): TruckingShipmentDto {
    return this._shipment;
  }
  public set shipment(value: TruckingShipmentDto) {
    if (this._shipment === value)
      return;
    this._shipment = value;
    this.loadDisponibility();
  }

  private _selectedRouteExpand: TruckingRouteExpandDto;
  @Input()
  public set selectedRouteExpand(value: TruckingRouteExpandDto) {
      if (this._selectedRouteExpand === value)
          return;
      this._selectedRouteExpand = value;
      this.loadDisponibility();
  }
  public get selectedRouteExpand(): TruckingRouteExpandDto {
      return this._selectedRouteExpand;
  }

  public showAssignedSlots: boolean = false;


  public disponibilty: string;
  loadDisponibility(){
    if(this.selectedRouteExpand == null){
      this.loadDisponibilityByDateHour(HDateHour.now());
      return;
    }
    this.loadDisponibilityByDateHour(HDateHour.max(HDateHour.now(), this.selectedRouteExpand.dateHourFrom));
  }

  loadDisponibilityByDateHour(datehour: HDateHour){
    if( this.shipment == null || this.shipment.packages == null || this.shipment.packages.length == 0)
      return;

    if(HDateHour.isNullOrNullValue(datehour))
      datehour = HDateHour.now();

    let totdisponible: boolean = true;
    let algundisponible: boolean = false;
    this.shipment.packages.forEach(element => {
      
      if(HDateHour.isGreaterEqualsThan(datehour, element.dateHourMinToLoadPackage))
        algundisponible = true;
      else
        totdisponible = false;
    });

    this.actualizedDisponibilityByParams(totdisponible, algundisponible);
  }

  actualizedDisponibilityByParams(totdisponible: boolean, algundisponible: boolean){
    if(totdisponible)
      this.disponibilty = "TD";
    else if(algundisponible)
      this.disponibilty = "SD";
    else
      this.disponibilty = "ND";
  }

  getTextColor(data: HColor) {
    if (data != null)
      return HColor.getWhiteBlackFromColor(data.web);

    return HColor.getWhiteBlackFromColor(HColor.defaultColor().web);
  }
  getBackColor(data: HColor) {
    return HColor.getColorOrDefaultColor(data, HColor.defaultColor().web);
  }
  getColor(text: string) {
    return HColor.getWhiteBlackFromColor(HColor.getColorFromStringTable(text, this.homeController));
  }
  getBackgroundColor(text: string) {
    return HColor.getColorFromStringTable(text, this.homeController);
  }

  getNumber(num: number) {
    if (num == null)
      return 0;
    return num;
  }

  OnInit() {
  }

  public onCallBack() {
   
  }

  public pretty(value) {
    return JSON.stringify(value);
  }
}
